import { useContext } from "@max/max";
export function useEngineContext() {
    // @ts-expect-error no global
    const ctx = useContext(global._EngineGlobalContext);
    return ctx;
}
